module.exports = __webpack_public_path__ + "static/media/email_circled.49228840.svg";